import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import DialogBackdrop from "../ModalDialogs/DialogBackdrop";
import { useTranslation } from "react-i18next";

const GeneralPurposeDialog = ({
  state,
  setState,
  title,
  desc,
  showCloseButton = true,
  dialogOnClose = () => setState(false),
  enablePrimaryButton = false,
  primaryButtonText,
  primaryButtonAction,
  enableSecondaryButton = true,
  secondaryButtonText = "Close",
  secondaryButtonAction = () => setState(false),
  width = "max-w-5xl",
  enableHrBlock = true,
}) => {
  const { t } = useTranslation();
  return (
    <Transition appear show={state} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        open={state}
        onClose={dialogOnClose}
      >
        <DialogBackdrop />
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className={`inline-block w-full ${width} p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl`}
            >
              <Dialog.Title
                as="h2"
                className="dialog_label2 font-body text-xl font-bold text-left"
              >
                {title}

                {showCloseButton && (
                  <button
                    className="ui-default-dialog-close"
                    onClick={() => setState(false)}
                  >
                    <svg
                      className="ui-icon h-3.5 w-3.5"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-close"></use>
                    </svg>
                  </button>
                )}
              </Dialog.Title>
              {enableHrBlock && <hr />}

              <Dialog.Description className="max-w-xl">
                {desc}
              </Dialog.Description>

              <div className="flex justify-end">
                {enableSecondaryButton && (
                  <div className="block text-right mt-6">
                    <button
                      className="ui-btn-secondary min-w-[140px]"
                      aria-label={t("AgentGeneralPurposeDialog-button-label")}
                      onClick={secondaryButtonAction}
                    >
                      {secondaryButtonText}
                    </button>
                  </div>
                )}

                {enablePrimaryButton && (
                  <div className="block text-right mt-6">
                    <button
                      className="ui-btn-primary min-w-[140px]"
                      onClick={primaryButtonAction}
                    >
                      {primaryButtonText}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default GeneralPurposeDialog;
